import { MessagesResponseModel } from "../pages/shared/models/api/messages-response.model";
import { MessageModel } from "../pages/shared/models/message.model";
import { CustomersResponseModel } from "../management-pages/shared/model/customers-response.model";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getSectionMessages(sectionName: string, languageId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const filter = { section: sectionName };
    const queryParams: { [key: string]: any } = {};

    queryParams.langId = languageId || 1;

    // if (page) {
    //     queryParams['page'] = page;
    // }
    // if (limit) {
    //     queryParams['limit'] = limit;
    // }

    return axiosInstance
      .post(`${API_URL}/messages`, filter, {
        params: { ...queryParams },
        ...authorizationHeader,
      })
      .then((response) => response?.data as MessagesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

async function getAllMessages(
  filter: object = {},
  limit?: number,
  page?: number,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(`${API_URL}/all-messages`, filter, {
        params,
        ...authorizationHeader,
      })
      .then((response) => {
        return response?.data as CustomersResponseModel;
      });
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      data: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getMessageById(messageId: string) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/messages/${messageId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function addMessage(message: MessageModel) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/messages/create`,
      message,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function editMessage(messageId: number, message: MessageModel) {
  try {
    delete message.messageId;
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.put(
      `${API_URL}/messages/${messageId}`,
      message,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function deleteMessage(messageId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/messages/${messageId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getSectionMessages,
  getMessageById,
  getAllMessages,
  addMessage,
  editMessage,
  deleteMessage,
};
